







































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import HtmlEditor from "../controls/HtmlEditor.vue";
import Loading from "../general/Loading.vue";
import CategoryTypeInput from "../general/CategoryTypeInput.vue";
import ExpandableView from "../controls/ExpandableView.vue";
import RentalProductDetailsCondition from "./RentalProductDetailsCondition.vue";
import ImageSelectBase64 from "../general/ImageSelectBase64.vue";

import SettingsJson from "../../shared/SettingsJson";
import RentalItemJson, { defaultRentalItemJson, RentalItemAllowedTags } from "../../shared/RentalItemJson";
import ItemDescriptionJson, { defaultItemDescriptionJson } from "../../shared/ItemDescriptionJson";
import RentalConditionJson, { defaultRentalConditionJson } from "../../shared/RentalConditionJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";

import Utils from "../../shared/Utils";
import { WeekDay, AllWeekDays, WeekDayNames } from "../../shared/WeekDay";
import { Month, AllMonths, MonthNames } from "../../shared/Month";
import PriceTemplateManualJson, { PriceTemplateManual } from "../../shared/PriceTemplateManualJson";
import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateRentalItemJson, validateRentalItemJsonAdd } from "../../shared/RentalItemJson";

import PriceTemplates from "../custom/PriceTemplates";
export default Vue.extend({
  name: "RentalProductDetails",
  components: {
    OverlayWindow,
    PointerMenu,
    HtmlEditor,
    Loading,
    CategoryTypeInput,
    ExpandableView,
    RentalProductDetailsCondition,
    ImageSelectBase64,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    productId: Number,
    mode: String,
    categories: Array,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      Utils: Utils,
      AllWeekDays: AllWeekDays,
      WeekDayNames: WeekDayNames,
      AllMonths: AllMonths,
      MonthNames: MonthNames,
      CategoryTypeType: CategoryTypeType,
      RentalItemAllowedTags: RentalItemAllowedTags,
      PriceTemplates: PriceTemplates as PriceTemplateManual,
      supportsDatePicker: false,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      detailsMode: "",
      selectedProductId: null as number | null,
      productDetails: null as RentalItemJson | null,
      rentalConditionsStartLength: 0 as number,
      additionalRentalConditionsStartLength: 0 as number,
      hasChanges: false,
      hintChanged: {
        state: false as boolean,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<RentalItemJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initProductDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    initProductDetails() {
      this.selectedProductId = this.productId;
      this.loadProductDetails();

      this.selectDetailsMode(this.mode);
    },

    setCachedData() {
      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadProductDetails() {
      if (this.selectedProductId != null) {
        if (this.restClient != null) {
          try {
            this.productDetails = await this.restClient.getRentalItem(this.selectedProductId);

            this.rentalConditionsStartLength = this.productDetails.rentalConditions.length;
            this.additionalRentalConditionsStartLength = this.productDetails.additionalRentalConditions.length;
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.productDetails = defaultRentalItemJson();
      }

      this.setCachedData();
      this.hasChanges = false;
    },

    //START set cached data

    //END set cached data

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Produkt hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Produkt bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Produkt";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
        this.hasChanges = false;
        this.loadProductDetails();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
          this.hasChanges = false;
          this.loadProductDetails();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.productDetails != null) {
        this.validation = validateRentalItemJson(this.productDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //description

    toggleProductDescription() {
      if (this.productDetails != null) {
        if (this.productDetails.description != null) {
          this.productDetails.description = null;
        } else {
          this.productDetails.description = defaultItemDescriptionJson();
        }
      }
    },

    //rentalConditions

    addRentalConditions() {
      if (this.productDetails != null) {
        this.productDetails.rentalConditions.push(defaultRentalConditionJson());
      }
    },

    deleteRentalConditions(index: number) {
      if (this.productDetails != null && this.productDetails.rentalConditions != null) {
        this.productDetails.rentalConditions.splice(index, 1);

        delete this.toValidate["rentalConditions-" + index];
      }
    },

    //additionalRentalConditions

    addAdditionalRentalConditions() {
      if (this.productDetails != null) {
        this.productDetails.additionalRentalConditions.push(defaultRentalConditionJson());
      }
    },

    deleteAdditionalRentalConditions(index: number) {
      if (this.productDetails != null && this.productDetails.additionalRentalConditions != null) {
        this.productDetails.additionalRentalConditions.splice(index, 1);

        delete this.toValidate["additionalRentalConditions-" + index];
      }
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    async addNewProduct() {
      if (this.productDetails != null) {
        this.loadingGeneral = true;
        this.submitValidation = true;

        this.validation = validateRentalItemJsonAdd(this.productDetails);

        if (this.validation != null && this.validation.isValid == true) {
          try {
            this.productDetails = await this.restClient.addRentalItem(this.productDetails);
            alert("Das Produkt wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              if (this.productDetails != null) {
                this.selectedProductId = this.productDetails.ID;
              }

              this.hasChanges = false;
              this.loadingGeneral = false;
              this.submitValidation = false;
              //this.stopEditMode();
              this.closeDetails();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Das Produkt konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveProductDetails() {
      if (this.productDetails != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;
          this.submitValidation = true;

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateRentalItemJson(this.productDetails);
          //todo ###END

          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                let updatedproductDetails = await this.restClient.updateRentalItem(this.productDetails);

                this.hasChanges = false;
                this.loadingGeneral = false;
                this.submitValidation = false;
                //this.stopEditMode();
                this.closeDetails();

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.");
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteProduct() {
      if (this.selectedProductId != null) {
        let c = confirm("Wollen Sie dieses Produkt wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteRentalItem(this.selectedProductId);
              this.closeDetails();
              alert("Das Produkt wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    productDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
